import SoundManager from "../sound/SoundManager";

export const setupButtonClick = function(btn, callback, scale = true) {
    btn.setInteractive();

    btn.originalScale = btn.scaleX;

    btn.actived = false;

    btn.on('pointerout',() => {
        btn.pressed = false;
    })

    btn.on('pointerdown', () => {
        btn.pressed = true;
    })

    btn.on('pointerup', () => {
        if(btn.pressed && !btn.actived){
            SoundManager.playFX("button_click");
            btn.pressed = false;
            btn.actived = true;
            callback();
        }
    })

    btn.on("pointerover", () => {
        if(scale){
            btn.scene.tweens.add({
                targets: [btn],
                scale: btn.originalScale * 1.2,
                ease: Phaser.Math.Easing.Sine.Out,
                duration: 100
            })
        }
        //btn.setScale(btn.originalScale * 1.2);
    })

    btn.on("pointerout", () => {
        if(scale){
            btn.scene.tweens.add({
                targets: [btn],
                scale: btn.originalScale,
                ease: Phaser.Math.Easing.Sine.Out,
                duration: 100
            })
        }
        //btn.setScale(btn.originalScale);
    })
}